module.exports = __webpack_public_path__ + "static/media/fusspflege-logo.d663cc9b.png";